module.exports = __webpack_public_path__ + "static/img/s4.0cb6079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s4.png
// module id = 9bd0
// module chunks = 0